/* ==========================================================================
   TNF PROMOTION SETTINGS 1.0.0                                  27 Sep 2026
   ONE PLACE TO CONTROL THE SALE.

   This is the only file to edit to change a promotion. The storefront, the
   catalogue order service and the custom creator service all read it, so a
   percentage changed here changes the price on the card, on the product page,
   in the creator, in the cart and at the checkout together. Nobody has to
   remember to edit three pricing engines and keep them in step.

   WHAT TO EDIT
     sale.enabled ............ true turns the sale on, false turns it off
     sale.startsAt / endsAt .. optional window; null means "no limit"
     sale.rates.halloween .... the Halloween percentage, as a fraction (0.30)
     sale.rates.standard ..... every other catalogue sign (0.25)
     sale.rates.creator ...... Design Your Own signs (0.25)
     sale.halloweenHandles ... which designs take the Halloween rate
     accessories ............. the accessory prices, controlled separately
                               from the sale and never discounted

   HOW THE MONEY IS WORKED OUT
   The reduction comes off the regular sign price the customer is shown, to
   the nearest cent, once. Accessories are taken out first and added back at
   their full price. A$657 less 25% is A$492.75. A$995 less 25% plus a A$20
   battery pack is A$766.25. Re-running or restarting a promotion cannot
   discount an already discounted price: every quote is rebuilt from the
   manufacturer cost, so there is no reduced number to reduce again.

   AFTER EDITING
     theme    - upload this file to the theme's assets
     services - ./tnf-sale-deploy.sh install   (ships this file to both)
   ========================================================================== */
(function (root) {
  'use strict';

  var SETTINGS = {
    version: '1.0.0',
    updated: '2026-09-27',

    sale: {
      /* ---------------- the switch ---------------- */
      enabled: true,
      id: 'tnf-sale-2026-10',
      title: 'Sale',
      halloweenTitle: 'Halloween Sale',

      /* ---------------- the window ----------------
         ISO dates, or null for no limit. Both ends are inclusive. */
      startsAt: null,
      endsAt: null,

      /* ---------------- the percentages ----------------
         Fractions, not percentages: 0.30 is 30% off. */
      rates: {
        halloween: 0.30,
        standard: 0.25,
        creator: 0.25
      },

      /* Which designs take the Halloween rate. A HANDLE list, not a collection
         lookup: the storefront and both services must reach the same answer
         without asking Shopify, or the page and the charge could disagree while
         a lookup is stale. Add a handle here to move a design to the Halloween
         rate; anything not listed takes the standard rate, and a creator design
         (which sends no handle at all) takes the creator rate. */
      halloweenHandles: [
        'alien-led-neon-sign', 'angry-pumpkin', 'balaclava-ghost', 'bed-sheet-ghost',
        'boo-ghost-led-neon-sign', 'booo', 'booo-1', 'ghost-1', 'halloween',
        'hell-here-hello-there', 'scream', 'simple-bat', 'simple-ghost-1',
        'simple-pumpkin', 'simple-spider', 'trick-or-treat-1', 'trick-or-treat-2'
      ],

      /* Accessories are never part of the reduction. */
      excludeAccessories: true
    },

    /* ---------------- accessory prices ----------------
       Controlled separately from the sale, and never discounted. Local-market
       amounts: A$ in Australia, US$ in the USA, never converted. The wall
       mounting kit has three alternative finishes - choosing one REPLACES the
       charge, it never accumulates. */
    accessories: {
      hanging_kit: 10,
      tape_3m: 10,
      battery_pack: 20,
      wall_finish: { silver: 0, black: 10, gold: 10 }
    }
  };

  root.TNF_PROMOTION_SETTINGS = SETTINGS;
  if (typeof module !== 'undefined' && module.exports) module.exports = SETTINGS;
})(typeof window !== 'undefined' ? window : globalThis);
